<header>
  @if (isSRLoaded) {
    <div class="container">
      <div class="logo" ifSettingFalse="Global_HeaderLogo_Xl_Enabled">
        <a [sf-aria-label]="'Global_Header_Logo_Aria_Label'" [routerLink]="globalHeaderLogoUrl" gtmClick="Logo" [gtmLinkURL]="globalHeaderLogoUrl">
          <adp-image imageKey="Global_Header_Logo"></adp-image>
        </a>
      </div>
      <div class="logo-xl" ifSettingTrue="Global_HeaderLogo_Xl_Enabled">
        <a [sf-aria-label]="'Global_Header_Logo_Aria_Label'" [routerLink]="globalHeaderLogoUrl" gtmClick="Logo" [gtmLinkURL]="globalHeaderLogoUrl">
          <adp-image imageKey="Global_Header_Logo"></adp-image>
        </a>
      </div>
      <!-- NEW: Minimal SR header row -->
      @if (isServiceRequestMode) {
        <nav [sf-aria-label]="'Global_Nav_Aria_Label'">
          <a
            href="javascript:void(0)"
            [gtmClick]="getResourceViewLabel('Global_Header_Exit_Request_Label')"
            (click)="onExitServiceRequest()"
            ><adp-label labelKey="Global_Header_Exit_Request_Label"></adp-label
          ></a>
        </nav>
      } @else if (isRenewPlanMode) {
        <nav [sf-aria-label]="'Global_Nav_Aria_Label'">
          <button
            type="button"
            mat-icon-button
            class="header-close-button"
            [gtmClick]="getResourceViewLabel('Global_Header_Exit_Renewal_Aria_Label')"
            sf-aria-label="Global_Header_Exit_Renewal_Aria_Label"
            (click)="onExitRenewPlan()">
            <mat-icon aria-hidden="true">close</mat-icon>
          </button>
        </nav>
      } @else {
        @if (isMainNavVisible) {
          <nav [sf-aria-label]="'Global_Nav_Aria_Label'">
            @if (
              (headerLoggedOutSettings && headerLoggedOutSettings.length && !isAuthenticated) ||
              (headerLoggedInSettings && headerLoggedInSettings.length && isAuthenticated && (this.userSettings.$selectedPlan | async)) ||
              chooseLanguage
            ) {
              <div class="options-panel d-lg-none">
                @if (!isOpen && isAuthenticated && requestServiceItem() && (headerService.showServiceButtonVisible$ | async) && !serviceRequestVisibility.isHidden()) {
                  <div class="slide-container" animate.enter="slide-enter" animate.leave="slide-leave">
                    <button
                      class="mat-button-style request-service-button"
                      mat-flat-button
                      color="accent"
                      [gtmClick]="requestServiceItem().Caption"
                      gtmClick="/service-request"
                      [gtmLinkURL]="requestServiceItem().LinkUrl"
                      (click)="onClickServiceRequest()">
                      <span class="utility-button-l d-flex align-items-center justify-content-center">
                        {{ requestServiceItem().Caption }}
                      </span>
                    </button>
                  </div>
                }
                <div class="menu-container">
                  <button
                    type="button"
                    class="menu"
                    [attr.aria-expanded]="isOpen"
                    sf-aria-label="Global_Menu_Toggle_Aria_Label"
                    (click)="onToggleMenu()"
                    [ngClass]="isOpen ? 'open' : ''">
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                  </button>
                </div>
              </div>
            }
            @if (!isAuthenticated && isCreateAccountOpen && createAccountSetting) {
              @if (headerService.showCreateAccountOptions$ | async) {
                @let item = createAccountSetting;
                <div class="create-account d-none d-lg-block">
                  <ul class="links">
                    <li class="header-route">
                      <a (click)="routeToLogin(item)" [gtmClick]="item.Caption" [gtmLinkURL]="item.LinkUrl">{{ item.Caption }}</a>
                    </li>
                  </ul>
                </div>
                <div class="menu d-lg-none">
                  <a
                    href="javascript:void(0)"
                    class="login-icon"
                    sf-aria-label="Global_Header_Login_Aria_Label"
                    (click)="routeToLogin(item)"
                    [gtmClick]="item.Caption"
                    [gtmLinkURL]="item.LinkUrl">
                    <mat-icon aria-hidden="true" svgIcon="user-blue"></mat-icon>
                  </a>
                </div>
              }
            } @else if (!isAuthenticated) {
              <div class="logged-out d-none d-lg-block" [class.no-nav-divider]="isHomePage() || hideLoggedOutNavDividerAlways()">
                @if (headerLoggedOutSettings?.length) {
                  <ul class="links">
                    @for (item of headerLoggedOutSettings; track $index) {
                      <li class="header-route" [class.find-my-plan-route]="isFindMyPlanItem(item)">
                        @if (item.LinkUrl.startsWith('^')) {
                          <button
                            id="claimsSupportMenu"
                            mat-flat-button
                            [matMenuTriggerFor]="programMenu"
                            (menuOpened)="isProgramMenuOpen = true"
                            (menuClosed)="isProgramMenuOpen = false"
                            [gtmClick]="item.Caption"
                            [gtmLinkURL]="item.LinkUrl">
                            <span style="font-size: 1rem !important; font-weight: 600 !important">{{ item.Caption }}</span>
                            <mat-icon style="margin-left: 5px" [class.rotated]="isProgramMenuOpen">expand_more</mat-icon>
                          </button>
                          <mat-menu #programMenu="matMenu">
                            <ng-container>
                              @for (childItem of programInfoLinks; track childItem) {
                                <button mat-menu-item [gtmClick]="childItem.Caption" [gtmLinkURL]="childItem.LinkUrl" (click)="this.claimsButtonClick(childItem)">
                                  {{ childItem.Caption }}
                                </button>
                              }
                            </ng-container>
                          </mat-menu>
                        } @else if (item.LinkUrl.startsWith('languages')) {
                          <a [title]="chooseLanguageTitle" class="language-toggle" href="javascript:void(0);" (click)="toggleLanguage()" [gtmClick]="chooseLanguage">{{ chooseLanguage }}</a>
                        } @else if (item.LinkUrl.startsWith('http')) {
                          <a [href]="item.LinkUrl" [target]="item.OpenNewTab ? '_blank' : '_self'" routerLinkActive="active" [gtmClick]="item.Caption" [gtmLinkURL]="item.LinkUrl">{{ item.Caption }}</a>
                        } @else {
                          @if (chooseLanguage && !logoutHeaderHasLanguage) {
                            <a [title]="chooseLanguageTitle" class="language-toggle" href="javascript:void(0);" (click)="toggleLanguage()" [gtmClick]="chooseLanguage">{{ chooseLanguage }}</a>
                          }
                          @if (item.LinkUrl.startsWith('/login')) {
                            <a class="active" routerlinkactive="active" (click)="routeToLogin(item)" [gtmClick]="item.Caption" [gtmLinkURL]="item.LinkUrl">{{ item.Caption }}</a>
                          } @else {
                            <a
                              [routerLink]="item.LinkUrl"
                              [target]="!!item.OpenNewTab ? '_blank' : null"
                              [routerLinkActive]="isFindMyPlanItem(item) ? [] : 'active'"
                              [class.active]="isFindMyPlanItem(item) && isFindMyPlanRoute()"
                              [gtmClick]="item.Caption"
                              [gtmLinkURL]="item.LinkUrl">{{
                              item.Caption
                            }}</a>
                          }
                        }
                      </li>
                    }
                  </ul>
                } @else if (chooseLanguage) {
                  <a [title]="chooseLanguageTitle" class="language-toggle language-noheaders" href="javascript:void(0);" (click)="toggleLanguage()" [gtmClick]="chooseLanguage">{{ chooseLanguage }}</a>
                }
              </div>
            } @else if (this.userSettings.$selectedPlan | async) {
              <div class="logged-in d-none d-lg-block">
                @if (headerLoggedInSettings) {
                  <ul class="links">
                    @for (item of headerLoggedInSettings; track $index) {
                      <li
                        class="header-route"
                        [ngStyle]="{
                          'margin-right': item.LinkUrl.endsWith('action_coverage') || item.LinkUrl.endsWith('action_claims_support') ? '10px' : item.LinkUrl === '/service-request' ? '10px' : '',
                          'margin-left':
                            item.LinkUrl.endsWith('action_coverage') || item.LinkUrl.endsWith('action_claims_support')
                              ? '18px'
                              : isFixedHeaderEnabled() && item.LinkUrl === 'action_profile'
                                ? '0px'
                                : '',
                        }">
                        <!-- User Profile Menu has different template -->
                        @if (item.LinkUrl === '/service-request') {
                          @if ((headerService.showServiceButtonVisible$ | async) && !serviceRequestVisibility.isHidden()) {
                            <div class="slide-container" animate.enter="slide-enter" animate.leave="slide-leave" [style.display]="serviceRequestVisibility.isHidden() ? 'none' : 'block'">
                              <button
                                id="requestServiceButton"
                                class="mat-button-style request-service-button"
                                mat-flat-button
                                color="accent"
                                [gtmClick]="item.Caption"
                                [gtmLinkURL]="item.LinkUrl"
                                (click)="onClickServiceRequest()">
                                <span class="utility-button-l d-flex align-items-center justify-content-center">
                                  {{ item.Caption }}
                                </span>
                              </button>
                            </div>
                          }
                        } @else if (item.LinkUrl !== 'action_profile' && !item.LinkUrl.endsWith('action_claims_support') && !item.LinkUrl.endsWith('action_coverage')) {
                          @if (this.checkRouteAvailability(item.LinkUrl)) {
                            <a
                              #navLink
                              id="{{ this.menuId(item.LinkUrl) }}"
                              [routerLink]="item.LinkUrl"
                              [target]="item.OpenNewTab === true ? '_blank' : null"
                              routerLinkActive="active"
                              (keydown.enter)="navLink.click()"
                              [gtmClick]="item.Caption"
                              [gtmLinkURL]="item.LinkUrl"
                              [ngClass]="isTechServicesInMenu && (item.LinkUrl.endsWith('devices') || item.LinkUrl.endsWith('services')) ? 'active-after' : ''">
                              {{ item.Caption }}
                            </a>
                          }
                        } @else if (item.LinkUrl === 'action_profile') {
                          @if (chooseLanguage) {
                            <a [title]="chooseLanguageTitle" class="language-toggle" href="javascript:void(0);" (click)="toggleLanguage()" [gtmClick]="chooseLanguage">{{ chooseLanguage }}</a>
                          }
                          <button
                            id="profileButton"
                            mat-flat-button
                            class="user"
                            [matMenuTriggerFor]="profileMenu"
                            style="cursor: pointer; flex-direction: row-reverse"
                            (menuOpened)="isProfileMenuOpen = true"
                            (menuClosed)="isProfileMenuOpen = false"
                            gtmClick="action_profile"
                            [gtmLinkURL]="item.LinkUrl"
                            [attr.aria-label]="isUserIconAvatar() ? profileButtonAriaLabel : null">
                            <span [ngClass]="isShowGenericAvatar ? 'generic-circle' : 'circle'">
                              @if (isUserIconAvatar()) {
                                <pgh-avatar [showUserIcon]="true" size="48"></pgh-avatar>
                              } @else if (userFullName) {
                                <pgh-avatar name="{{ userFullName }}" color="{{ userAvatarColor }}" size="48"></pgh-avatar>
                              }
                            </span>
                            @if (!isShowGenericAvatar) {
                              <mat-icon [class.rotated]="isProfileMenuOpen">expand_more</mat-icon>
                            }
                          </button>
                          <mat-menu #profileMenu="matMenu">
                            @if (!areLinksLoaded) {
                              @for (childItem of defaultProfileLinks; track childItem) {
                                <button mat-menu-item [gtmClick]="childItem?.Caption" [gtmLinkURL]="childItem.LinkUrl" (click)="this.profileButtonClick(childItem)">
                                  {{ childItem?.Caption }}
                                </button>
                              }
                            } @else {
                              <div class="mat-profile-info">
                                <span class="circle">
                                  @if (isUserIconAvatar()) {
                                    <pgh-avatar [showUserIcon]="true" size="48"></pgh-avatar>
                                  } @else if (userFullName) {
                                    <pgh-avatar name="{{ userFullName }}" color="{{ userAvatarColor }}" size="48"></pgh-avatar>
                                  }
                                </span>
                                @if (!isUserIconAvatar()) {
                                  <span class="user-given-name cls_mask">{{ userGivenName && item.Caption.replace('{name}', userGivenName) }}</span>
                                }
                              </div>
                              @for (childItem of profileLinks; track childItem) {
                                <button mat-menu-item [gtmClick]="childItem.Caption" [gtmLinkURL]="childItem.LinkUrl" (click)="this.profileButtonClick(childItem)">
                                  {{ childItem.Caption }}
                                </button>
                              }
                            }
                          </mat-menu>
                        } @else if (item.LinkUrl === 'action_claims_support') {
                          <button
                            id="claimsSupportMenu"
                            mat-flat-button
                            [matMenuTriggerFor]="claimsMenu"
                            (menuOpened)="isClaimsMenuOpen = true"
                            (menuClosed)="isClaimsMenuOpen = false"
                            [gtmClick]="item.Caption"
                            [ngClass]="isTechServicesInMenu ? 'button-active-after' : ''">
                            <span style="font-size: 1rem !important; font-weight: 600 !important">{{ item.Caption }}</span>
                            <mat-icon style="margin-left: 5px" [class.rotated]="isClaimsMenuOpen">expand_more</mat-icon>
                          </button>
                          <mat-menu #claimsMenu="matMenu">
                            @if (!areClaimsLinksLoaded) {
                              @for (childItem of defaultClaimsLinks; track childItem) {
                                <button mat-menu-item [gtmClick]="childItem.Caption" [gtmLinkURL]="childItem.LinkUrl" (click)="this.claimsButtonClick(childItem)">
                                  {{ childItem?.Caption }}
                                </button>
                              }
                            } @else {
                              @for (childItem of claimsLinks; track childItem) {
                                <button mat-menu-item [gtmClick]="childItem.Caption" [gtmLinkURL]="childItem.LinkUrl" (click)="this.claimsButtonClick(childItem)">
                                  {{ childItem.Caption }}
                                </button>
                              }
                            }
                          </mat-menu>
                        } @else {
                          <button
                            id="coverageMenu"
                            mat-flat-button
                            [matMenuTriggerFor]="coverageMenu"
                            (menuOpened)="isCoverageMenuOpen = true"
                            (menuClosed)="isCoverageMenuOpen = false"
                            [gtmClick]="item.Caption"
                            [ngClass]="isTechServicesInMenu ? 'button-active-after' : ''">
                            <span style="font-size: 1rem !important; font-weight: 600 !important">{{ item.Caption }}</span>
                            <mat-icon style="margin-left: 5px" [class.rotated]="isCoverageMenuOpen">expand_more</mat-icon>
                          </button>
                          <mat-menu #coverageMenu="matMenu">
                            @if (!areCoverageLinksLoaded) {
                              @for (childItem of defaultCoverageLinks; track childItem; let i = $index) {
                                <button
                                  mat-menu-item
                                  [gtmClick]="childItem.Caption"
                                  [gtmLinkURL]="childItem.LinkUrl"
                                  [ngClass]="defaultCoverageLinks.length > 1 ? '' : 'noMenuLine'"
                                  (click)="this.coverageButtonClick(childItem)">
                                  {{ childItem?.Caption }}
                                </button>
                              }
                            } @else {
                              @for (childItem of coverageLinks; track childItem) {
                                <button
                                  mat-menu-item
                                  [gtmClick]="childItem.Caption"
                                  [gtmLinkURL]="childItem.LinkUrl"
                                  [ngClass]="defaultCoverageLinks.length > 1 ? '' : 'noMenuLine'"
                                  (click)="this.coverageButtonClick(childItem)">
                                  {{ childItem.Caption }}
                                </button>
                              }
                            }
                          </mat-menu>
                        }
                      </li>
                    }
                  </ul>
                }
              </div>
            }
          </nav>
        }
      }
    </div>
  }
</header>
